/**
 * Role-tier split (ADR Section 16, ADR-2026-07-D). Fixed-tier roles are the platform's own team —
 * they keep the single shared/unthemed dashboard UI forever, regardless of `active_theme`, since
 * Basera's design system specifies zero admin screens. Every other role is themed-tier: their
 * pages, modals, and toasts follow the platform-wide active theme via `DashboardThemeSlot`.
 *
 * Typed as `string[]` (not `UserRole[]`) because `useAuthStore`'s `user.roles` is itself typed
 * as `string[]` (see stores/authStore.ts) — same loose-typing precedent `ThemeProvider.tsx`'s
 * `PREVIEW_ALLOWED_ROLES` already established.
 */
export const FIXED_TIER_ROLES: string[] = ['SUPER_ADMIN', 'PLATFORM_ADMIN', 'PLATFORM_STAFF'];

export function isFixedTierRole(role: string | undefined | null): boolean {
  return !!role && FIXED_TIER_ROLES.includes(role);
}
